<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  externalClasses: ['extern-class'],
  props: {
    // '普通文本{{高亮文本}}普通文本\n换行后的[[特殊行高文本]]普通文本'
    text: {
      type: String,
      value: ''
    },
    color: {
      type: String,
      value: '#333'
    },
    textStyle: {
      type: Object,
      value: {}
    },
    hlColor: {
      type: String,
      value: '#FF5900'
    },
    hlStyle: {
      type: Object,
      value: {}
    },
    specialLineHeight: {
      type: String,
      value: '1'
    }
  },
  computed: {
    texts() {
      return this.filterHighlightText(this.text)
    },
    highlightStyle() {
      return {
        ...this.textStyle,
        ...this.hlStyle,
        color: this.hlColor
      }
    },
    commonStyle() {
      return {
        ...this.textStyle,
        color: this.color
      }
    },
    speciaLineHeightlStyle() {
      return {
        ...this.commonStyle,
        lineHeight: this.specialLineHeight
      }
    }
  },
  methods: {
    filterHighlightText(str = '') {
      const regex = /({{.*?}})|(\[\[.*?\]\])/g;
      return str
        .split(regex)
        .map((item) => {
          if (item && item.startsWith('{{') && item.endsWith('}}')) {
            return { value: item.substring(2, item.length - 2), highlight: true, specialLineHeight: false };
          } else if (item && item.startsWith('[[') && item.endsWith(']]')) {
            return { value: item.substring(2, item.length - 2), highlight: false, specialLineHeight: true };
          }
          return { value: item, highlight: false, specialLineHeight: false };
        })
        .filter(({ value }) => value);
    }
  }
})
</script>

<template>
  <text class="vam externClass extern-class">
    <text
      class="vam"
      wx:for="{{texts}}"
      wx:key="index"
      wx:style="{{ item.highlight ? highlightStyle : (item.specialLineHeight ? speciaLineHeightlStyle : commonStyle) }}"
      >{{ item.value }}</text
    >
    <slot />
  </text>
</template>

<style lang="stylus" scoped>
.vam
  vertical-align middle
</style>

<script name="json">
module.exports = {
  component: true
}
</script>
